import { Link } from "react-router-dom";
import { resolveImageUrl, optimizedImageUrl } from "@/lib/api";

export const HeroSection = ({ content }) => {
  const align = content.alignment === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <section className="relative min-h-[60vh] sm:min-h-[70vh] flex items-center" data-testid="hero-section">
      {content.background_image ? (
        <div className="absolute inset-0">
          <img
            src={optimizedImageUrl(resolveImageUrl(content.background_image), 1920)}
            alt=""
            fetchpriority="high"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/45 to-black/25" />
        </div>
      ) : (
        <div className="absolute inset-0 bg-secondary" />
      )}
      <div className={`relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-20 flex flex-col ${align}`}>
        {content.eyebrow && (
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-white/80 mb-4" data-testid="hero-eyebrow">
            {content.eyebrow}
          </p>
        )}
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white leading-[1.02] mb-5 max-w-3xl" data-testid="hero-heading">
          {content.heading}
        </h1>
        {content.description && (
          <p className="text-base sm:text-lg text-zinc-100 max-w-xl mb-8 leading-relaxed" data-testid="hero-description">
            {content.description}
          </p>
        )}
        <div className="flex flex-wrap gap-4">
          {content.primary_label && (
            <Link to={content.primary_url || "/inventory"} className="btn-themed" data-testid="hero-primary-cta">
              {content.primary_label}
            </Link>
          )}
          {content.secondary_enabled && content.secondary_label && (
            <Link to={content.secondary_url || "/contact"} className="btn-themed-outline border-white/50 text-white hover:border-primary hover:text-primary" data-testid="hero-secondary-cta">
              {content.secondary_label}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
};
